import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import PageSkeleton from './components/PageSkeleton/PageSkeleton';
import './App.css';

const Home = lazy(() => import('./pages/Home/Home'));
const Services = lazy(() => import('./pages/Services/Services'));
const Contact = lazy(() => import('./pages/Contact/Contact'));
const Sms = lazy(() => import('./pages/Sms/Sms'));
const AdminSms = lazy(() => import('./pages/AdminSms/AdminSms'));
const Privacy = lazy(() => import('./pages/Privacy/Privacy'));
const Terms = lazy(() => import('./pages/Terms/Terms'));
const ClientPortal = lazy(() => import('./pages/ClientPortal/ClientPortal'));
const BusinessAdmin = lazy(() => import('./pages/BusinessAdmin/BusinessAdmin'));

function PageFallback() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin')) return <p role="status">Loading your workspace…</p>;
  const variant = pathname === '/services' || pathname === '/contact' ? 'form' : 'default';
  return <PageSkeleton variant={variant} />;
}

function AnimatedRoutes() {
  const location = useLocation();
  const portalHost = window.location.hostname === 'clients.flygonlc.com';

  return (
    <div key={location.pathname} className="page-transition">
      <Suspense fallback={<PageFallback />}>
        <Routes location={location}>
          <Route path="/" element={portalHost ? <ClientPortal /> : <Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/sms" element={<Sms />} />
          <Route path="/admin/sms" element={<AdminSms />} />
          <Route path="/admin" element={<BusinessAdmin />} />
          <Route path="/admin/style" element={<BusinessAdmin />} />
          <Route path="/admin/analytics" element={<BusinessAdmin />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/terms-of-service" element={<Terms />} />
          <Route path="/clients/*" element={<ClientPortal />} />
          {portalHost && <Route path="*" element={<ClientPortal />} />}
        </Routes>
      </Suspense>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <main className="main-content">
          <AnimatedRoutes />
        </main>
      </div>
    </Router>
  );
}

export default App;
